import { useCallback } from "react";
import { useSolanaTransaction } from "@/hooks/useSolanaTransaction";
import { useMultiversXTransaction } from "@/hooks/useMultiversXTransaction";
import { NetworkType } from "@/components/BridgeWallet";
import { A1X_TOKEN } from "@/config/sharedConfig";

interface BridgeTransactionParams {
  fromNetwork: NetworkType;
  payInAddress: string;
  amount: string;
}

export const useBridgeTransactionHooks = () => {
  const solanaTransaction = useSolanaTransaction();
  const multiversXTransaction = useMultiversXTransaction();

  const executeBridgeTransaction = useCallback(
    async ({ payInAddress, amount }: BridgeTransactionParams) => {
      const fromNetwork = payInAddress.startsWith("erd")
        ? "multiversx"
        : "solana";

      if (fromNetwork === "solana") {
        return await solanaTransaction.sendTransaction({
          toAddress: payInAddress,
          amount,
        });
      } else {
        return await multiversXTransaction.sendTransaction({
          toAddress: payInAddress,
          amount,
          tokenIdentifier: A1X_TOKEN,
        });
      }
    },
    [solanaTransaction, multiversXTransaction]
  );

  const isLoading =
    solanaTransaction.isLoading || multiversXTransaction.isLoading;
  const error = solanaTransaction.error || multiversXTransaction.error;

  return {
    executeBridgeTransaction,
    isLoading,
    error,
  };
};
